import React, { useMemo } from 'react';
import { Form, Formik, FormikHelpers } from 'formik';
import * as Yup from 'yup';

import { Field, FieldAnswer } from '@app/api';
import { SubmitType } from '../fieldConfigurations';
import { CustomFormFieldSubmitButton } from '../components/CustomFormFieldSubmitButton';

interface Props {
  field: Field;
  onSubmit: (values: FieldAnswer, helpers: FormikHelpers<FieldAnswer>) => any;
  submitType?: SubmitType;
  children: React.ReactNode;
}

export const buildTextFieldValue = (field: Field): FieldAnswer => {
  return {
    type: 'text' as const,
    field: {
      id: field.id,
      type: field.type,
      ref: field.ref,
      title: field.title,
    },
    text: '',
  };
};

export const TextFieldForm = ({
  field,
  onSubmit,
  children,
  submitType = SubmitType.DONE,
}: Props) => {
  const initialValues = useMemo(() => buildTextFieldValue(field), [field]);

  const validationSchema = useMemo(
    () =>
      Yup.object().shape({
        text:
          field.validation && field.validation.required
            ? Yup.string().required()
            : Yup.string().notRequired(),
      }),

    [field],
  );

  return (
    <Formik
      onSubmit={onSubmit}
      validationSchema={validationSchema}
      initialValues={initialValues}
      key={field.id}
    >
      {({ values }) => (
        <Form>
          {children}
          <CustomFormFieldSubmitButton
            submitType={submitType}
            disabled={!validationSchema.isValidSync(values)}
          />
        </Form>
      )}
    </Formik>
  );
};
